<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
    <fuse-vertical-navigation
        class="dark bg-gray-900 print:hidden"
        [mode]="'over'"
        [name]="'mainNavigation'"
        [navigation]="navigation.default"
        [opened]="false">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            <div class="flex items-center h-20 pt-6 px-8">
                <img
                    class="w-24"
                    src="assets/images/logo/logo-text-on-dark.svg"
                    alt="Logo image">
            </div>
        </ng-container>
    </fuse-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto items-center w-full min-w-0 bg-gray-200 dark:bg-card">

    <!-- Header -->
    <div class="relative flex flex-col flex-0 justify-center w-full h-16 sm:h-20 md:h-36 overflow-hidden z-49 shadow dark:shadow-none print:hidden">
        <!-- Top bar -->
        <div class="relative dark flex flex-auto justify-center w-full px-4 md:px-8 bg-gray-800 dark:bg-gray-900">
            <div class="flex items-center w-full max-w-360 h-16 sm:h-20">
                <!-- Logo -->
                <ng-container *ngIf="!isScreenSmall">
                    <div class="flex items-center">
                        <img
                            class="w-24"
                            src="assets/images/logo/logo-text-on-dark.svg"
                            alt="Logo image">
                    </div>
                </ng-container>
                <!-- Navigation toggle button -->
                <ng-container *ngIf="isScreenSmall">
                    <button
                        mat-icon-button
                        (click)="toggleNavigation('mainNavigation')">
                        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                    </button>
                </ng-container>
                <!-- Components -->
                <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
                    <scheme-select></scheme-select>
                    <languages></languages>
                    <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
<!--                    <search [appearance]="'bar'"></search>-->
<!--                    <shortcuts></shortcuts>-->
<!--                    <messages></messages>-->
                    <notifications></notifications>
                    <learning-panel></learning-panel>
                    <cart></cart>
<!--                    <button-->
<!--                        class="lg:hidden"-->
<!--                        mat-icon-button-->
<!--                        (click)="quickChat.toggle()">-->
<!--                        <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>-->
<!--                    </button>-->
                    <user></user>
                </div>
            </div>
        </div>
        <!-- Bottom bar -->
        <ng-container *ngIf="!isScreenSmall">
            <div class="flex flex-auto justify-center px-4 md:px-8 bg-card dark:bg-gray-700">
                <div class="relative flex items-center w-full max-w-360 h-16">
                    <fuse-horizontal-navigation
                        class="-mx-4"
                        [name]="'mainNavigation'"
                        [navigation]="navigation.horizontal"></fuse-horizontal-navigation>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- Content -->
    <div class="flex flex-auto justify-center w-full sm:p-6 md:p-8">
        <div class="flex flex-col flex-auto w-full sm:max-w-360 sm:shadow-lg sm:rounded-lg sm:overflow-hidden bg-default">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
            <expire-banner></expire-banner>
            <router-outlet *ngIf="true"></router-outlet>
        </div>
    </div>

    <!-- Footer -->
    <div class="relative flex flex-0 justify-center w-full px-6 md:px-8 z-49 border-t bg-card print:hidden">
        <div class="flex items-center w-full max-w-360 h-fit py-4 gap-4">
            <span class="font-medium text-secondary min-w-fit">Smiles Manager &copy; {{currentYear}}</span>
            <div class="flex flex-col gap-0 sm:flex-row sm:gap-4 items-center">
                <a
                    class="text-primary-500 hover:underline text-xs sm:text-md"
                    [routerLink]="['/contact']">
                    Contact
                </a>

                <a
                    class="text-primary-500 hover:underline text-xs sm:text-md"
                    [routerLink]="['/policy']"
                    [queryParams]="{type:'terms-and-conditions'}">
                    Termeni si conditii
                </a>

                <a
                    class="text-primary-500 hover:underline text-xs sm:text-md"
                    [routerLink]="['/policy']"
                    [queryParams]="{type:'confidentiality-policy'}">  Politica de confidentialitate
                </a>

                <a
                    class="text-primary-500 hover:underline text-xs sm:text-md"
                    [routerLink]="['/policy']"
                    [queryParams]="{type:'delivery-policy'}">  Politica de livrare comanda
                </a>

                <a
                    class="text-primary-500 hover:underline text-xs sm:text-md"
                    [routerLink]="['/policy']"
                    [queryParams]="{type:'delivery-cancel-policy'}">  Politica de anulare comanda
                </a>

                <ng-container *ngIf="!isScreenSmall">
                    <div class="w-fit">
                        <a href="https://netopia-payments.com/" target="_blank" rel="noopener">
                            <img src="assets/images/ui/smm/footer/netopia.png" alt="Solutionare Litigii" class="h-8">
                        </a>
                    </div>
                    <div class="w-fit">
                        <a href="https://anpc.ro" target="_blank" rel="noopener">
                            <img src="assets/images/ui/smm/footer/anpc.jpg" alt="ANPC SAL" class="h-8">
                        </a>
                    </div>
                    <div class="w-fit">
                        <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO" target="_blank" rel="noopener">
                            <img src="assets/images/ui/smm/footer/solutionare_litigii.jpg" alt="Solutionare Litigii" class="h-8">
                        </a>
                    </div>
                </ng-container>

            </div>
        </div>
    </div>

</div>

<!-- Quick chat -->
<!--<quick-chat #quickChat="quickChat"></quick-chat>-->
